import { type ReassistRequestSummary } from "../types";

/** 検索用に全角半角・大文字小文字・前後の空白をそろえる。 */
export const normalizeQuery = (value: string): string =>
  value.normalize("NFKC").trim().toLowerCase();

/**
 * 依頼が検索語に部分一致するか。住所・マンション名・書類名・取得場所（役所）を対象にする。
 * 検索語が空なら常に一致する。
 */
export const matchesQuery = (
  request: ReassistRequestSummary,
  query: string
): boolean => {
  const q = normalizeQuery(query);
  if (q === "") return true;
  const targets = [
    request.address,
    request.buildingName,
    ...request.items.flatMap((item) => [item.label, item.location]),
  ];
  return targets.some((t) => normalizeQuery(t).includes(q));
};
